import { SVGProps, Ref, forwardRef } from 'react';

export const ForwardOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.481 4.155c.482-.37 1.16-.044 2.513.607l1.945.935C6.98 6.677 8 7.168 8 8s-1.02 1.322-3.06 2.303l-1.946.935-.896.421c-.72.32-1.175.442-1.524.246l-.093-.06c-.36-.278-.45-.824-.473-1.793L0 8.935v-1.87c0-1.693 0-2.54.481-2.91m.942 1.42c-.022.342-.023.81-.023 1.49v1.87c0 .679.001 1.147.023 1.49l.105-.044c.239-.106.515-.24.859-.405l1.946-.935C5.32 8.566 5.946 8.26 6.352 8c-.406-.26-1.032-.567-2.019-1.041l-1.946-.936c-.344-.165-.62-.298-.859-.404z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.481 4.155c.482-.37 1.16-.044 2.513.607l1.946.935C14.98 6.677 16 7.168 16 8s-1.02 1.322-3.06 2.303l-1.946.935-.896.421c-.72.32-1.175.442-1.524.246l-.093-.06c-.36-.278-.45-.824-.473-1.793L8 8.935v-1.87c0-1.693 0-2.54.481-2.91m.942 1.42c-.022.342-.023.81-.023 1.49v1.87c0 .679.001 1.147.023 1.49l.105-.044c.239-.106.515-.24.859-.405l1.946-.935c.987-.475 1.614-.78 2.019-1.041-.405-.26-1.032-.567-2.019-1.041l-1.946-.936c-.344-.165-.62-.298-.859-.404z"
                fill="currentColor"
            />
        </g>
    </svg>
));
ForwardOutlinedSize16Glyph.displayName = 'ForwardOutlinedSize16Glyph';
